<template>
  <div class="flex flex-col gap-y-3">
    <div
      v-for="groupKey in Object.keys(orderGroups)"
      :key="groupKey"
      class="flex gap-x-3"
      >
      <div class="flex flex-col font-medium py-3">
        <span>{{ receiveData(groupKey) }}</span>
        <span>{{ receiveWeek(groupKey) }}</span>
      </div>
      <div class="flex flex-col flex-grow gap-y-3">
        <order-card
          v-for="item in orderGroups[groupKey]"
          :key="item.id"
          :border-color="getBorderColor(item)"
          :item="item">
          <template #header>
            <div class="flex gap-1 items-center">
              <w-button
                v-if="item.status !== GROUP_BUYING_STATUS.END"
                :class="getHeaderButtonClass(item)"
                class="header-button"
                @click.prevent="$router.push(`/menu/${item.id}`)"
              >
                {{ getHeaderButtonText(item) }}
              </w-button>
              <w-button
                v-if="inValidReceiveTime(item) && showReceiveCode"
                class="text-xs"
                @click="onShowQrCodeClick(item)"
              >
                我的領取條碼
              </w-button>
            </div>
          </template>
        </order-card>
      </div>
    </div>
    <qr-code-dialog v-if="showQrCodeDialog" v-model="showQrCodeDialog" :orders="qrCodeOrders" />
  </div>
</template>

<script>
import MenuListItem from './MenuListItem';

export default MenuListItem;
</script>

<style lang="scss" scoped>
@import 'MenuListItem';
</style>
